import Swiper, { Navigation, FreeMode, A11y } from 'swiper'
Swiper.use([Navigation, FreeMode, A11y])

export const swiperGrid = () => {

  const sliders = document.querySelectorAll('[data-swiper-grid]')

  if (!sliders.length) return

  sliders.forEach(slider => {

    const cursor = document.querySelector('.mf-cursor')
    const nextEl = slider.parentElement.querySelector('.next')
    const prevEl = slider.parentElement.querySelector('.prev')

    const swiper = new Swiper(slider, {
      speed: 750,
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: {
        enabled: true,
        momentum: true,
        sticky: true
      },
      navigation: {
        nextEl,
        prevEl 
      },
      on: {
        reachBeginning: function () { cursor.classList.remove('-prev') },
        reachEnd: function () { cursor.classList.remove('-next') },
      }
    })

  })
}

export default () => {} 
